
import "@/assets/sass/template.scss";
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import store from "@/store";
import TableTab from "@/components/kt-datatable/TableTab.vue";
import PaginationUtill from "@/views/util/PaginationUtill";
export default defineComponent({
  name: "DataTable",

  components: {
    TableTab,
  },
  setup() {
    let accountId = store.getters.AccountId;
    const tableValuesUser = ref([]);
    const addition = ref(false);

    const loading = ref<boolean>(false);
    interface Tableheader {
      name: string;
      key: string;
      sortable: boolean;
    }

    const pageheaderUser = "User list";
    const TableHeadersUser = ref<Array<Tableheader>>();
    const OriginalTableHeadersUser = ref<Array<Tableheader>>();
    const colnamesUser = ref();

    onMounted(() => {
      setCurrentPageBreadcrumbs("User List", ["NA"]);

      addition.value = false;
    });

    loading.value = true;
    let domainName = store.getters.DomainName;
    const accountInfo: any = {
      accountid: accountId,
      stIndx: 1,
      enIndx: 500,
      DomainName: domainName,
    };

    ApiService.get(
      "api/users/userManagement"
    )
      .then((resp) => {

        colnamesUser.value = PaginationUtill.getUserManagementList.map((a) => a.key);

        OriginalTableHeadersUser.value = PaginationUtill.getUserManagementList.map(
          (a) => ({
            name: a.name,
            key: a.key,
            sortable: true,
          })
        );
        TableHeadersUser.value = PaginationUtill.getUserManagementList.map((a) => ({
          name: a.name,
          key: a.key,
          sortable: true,
        }));

        tableValuesUser.value = resp.data.usermodel.map((a) => a);

        loading.value = false;
        addition.value = true;
      })
      .catch((a) => {
        loading.value = false;
        console.log("API Error", a);
      });

    function openAssetAddition() {
      addition.value = true;
    }


    const downloadurl = "api/users/downloadFile";
    const downloadprops = accountInfo;
    return {
      downloadurl,
      downloadprops,
      pageheaderUser,
      colnamesUser,
      openAssetAddition,
      addition,
      tableValuesUser,
      loading,
      OriginalTableHeadersUser,
    };
  },
});
